import { HasType } from "../agent.card";
import { SelectorFn } from "./selectorFn";
import { isErrors } from "@me8eon/errors";


export type ComposeSelector<Selector> = {
    type: "compose"
    chain: Selector[]
    description?: string
}

export function composeSelector<Context, Selector extends HasType>(): SelectorFn<Context, ComposeSelector<Selector>> {
    return {
        isDefinedAt: () => true,
        execute: async ({ chain }, context, messages, sc) => {

            const fullLog: any[] = [];
            let lastSelected: string | undefined = undefined;
            for (const selector of chain) {
                const { type } = selector;
                const selFn = sc.selFns[type];
                if (!selFn) return { errors: [`Selector function for type ${type} not found. Legal values are ${Object.keys(sc.selFns).sort()}`], log: { whatHappened: "composeSelector", params: { selector } } };
                if (selFn.isDefinedAt && !selFn.isDefinedAt(selector, context, messages, sc)) return { errors: [`Selector function for type ${type} is not defined at this context`], log: { whatHappened: "composeSelector", params: { selector, context } } };
                const result = await selFn.execute(selector, context, messages, sc);
                fullLog.push({ type, result: result.log });
                if (isErrors(result)) return { ...result, log: { whatHappened: "composeSelector", params: fullLog } };
                const { value, log } = result;
                lastSelected = value.selected; // only the last selector will be used
                context = value.context;
                messages = value.messages;
            }
            return { value: { context, selected: lastSelected, messages }, log: { whatHappened: "composeSelector", params: { lastSelected, fullLog } } };
        },
    };
}
